<template>
    <v-layout class="fill-height">
    <v-container
        id="contentDashboard" fluid
        class="fill-height"
    >
        <v-snackbar
        v-model="snackbar"
        :color="color"
        right
        top
        app
        >
        {{snackbarText}}
        <v-btn
            text
            dark
            @click="snackbar = false"
        >
            Fermer
        </v-btn>
        </v-snackbar>
        <v-layout>
        <v-row
            align="start"
            justify="start"
        >
            <v-col cols="12" class="pt-1">
            <header-sidebar></header-sidebar>
            <v-card class="table-content">
                <v-card-title>
                    <div class="text-left">
                        <span style="font-weight:700">Mon Compte</span>
                    </div>
                <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text class="pa-0">
                    <v-row class="text-left" style="width:100%; margin:0;">
                        <v-col cols="12" md="7">
                            <p style="font-size: 16px;">Agent Associé</p>
                            <v-list-item class="mb-4" v-if="userdata.agent_id > 0">
                                <v-list-item-avatar>
                                <v-img
                                    v-if="userdata.agent.picture_url"
                                    :src="$baseURL + 'uploads/'+ userdata.agent.picture_url"
                                ></v-img>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                <v-list-item-title >{{userdata.agent.nom}}</v-list-item-title>
                                <v-list-item-subtitle>{{userdata.agent.titre_pro}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item class="mb-4" v-else>
                                <v-list-item-avatar>
                                <v-img
                                    :src="profile_picture_standard"
                                ></v-img>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                <v-list-item-title >Aucun agent n'est associé à ce compte.</v-list-item-title>
                                <v-list-item-subtitle>Associer</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <p style="font-size: 16px;">Mes Informations Personnelles</p>
                            <v-alert
                                color="red"
                                type="error"
                                outlined
                                v-show="alert"
                            >
                                {{message}}
                            </v-alert>
                            <v-form v-model="form">
                                <v-row>
                                    <v-col cols="12" md="12" class="pa-3">
                                        <v-text-field label="Nom d'utilisateur"  :error-messages="messages.username" :rules="[rules.required, rules.username]" hint="Le nom d'utilisateur doit être unique, composé au moins de 3 caractères alpha-numériques et simple à taper." persistent-hint v-model="userData.username" outlined></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="12" class="pa-3">
                                        <v-text-field label="Email" ref="email" :error-messages="messages.email" :rules="[rules.required, rules.email]" hint="L'email doit être valide." v-model="userData.email" outlined></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="12" class="pa-3">
                                        <v-text-field label="Type Compte" disabled v-model="userdata.permission_class" hide-details outlined></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="12" class="pa-3">
                                        <v-text-field label="Mot de passe Actuel" :error-messages="messages.password" persistent-hint hint="Veuillez entrer votre mot de passe actuel pour pouvoir effectuer un changement." type="password" ref="password" v-model="userData.password" outlined></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="12" class="pa-3">
                                        <v-text-field label="Nouveau Mot de passe" :rules="[rules.password]" :error-messages="messages.new_password"  ref="new_password" persistent-hint hint="Veuillez choisir une mot de passe contenant au moins 8 caractères." type="password" v-model="userData.new_password" outlined></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="12" class="pa-3">
                                        <v-text-field label="Confirmer Mot de passe" ref="confirm_password" :error-messages="messages.confirm_password" v-model="userData.confirm_password" type="password" outlined></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="12" class="pa-3">
                                        <div class="text-right">
                                            <v-btn @click="update" style="float:right; background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%);" color="primary">Editer</v-btn>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="12" class="pa-3">
                                    Dernière connexion le 10/10/2109 à 14:45:20
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="12" class="pa-3">
                                    Dernière Activité : Ajout avis d'arrivée N°895641 au Dossier N°20204651
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-col>
                        <v-col cols="12" md="5" v-if="userdata.permission !== 1">
                            <p style="font-size: 16px;">Mes Privilèges</p>
                            <v-row>
                                <v-col cols="12" md="4">
                                    <v-checkbox input-value="true" class="privilege-checkbox" label="Ajouter Dossier" disabled></v-checkbox>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-checkbox input-value="true" label="Editer Dossier" class="privilege-checkbox" disabled></v-checkbox>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-checkbox label="Supprimer Dossier"  class="privilege-checkbox" disabled></v-checkbox>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-checkbox input-value="true" class="privilege-checkbox" label="Ajouter Avis" disabled></v-checkbox>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-checkbox input-value="true" label="Editer Avis" class="privilege-checkbox" disabled></v-checkbox>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-checkbox label="Supprimer Avis"  class="privilege-checkbox" disabled></v-checkbox>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-checkbox input-value="true" class="privilege-checkbox" label="Ajouter Facture" disabled></v-checkbox>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-checkbox label="Editer Facture"  class="privilege-checkbox" disabled></v-checkbox>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-checkbox label="Supprimer Facture"  class="privilege-checkbox" disabled></v-checkbox>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-checkbox input-value="true" class="privilege-checkbox" label="Ajouter Client" disabled></v-checkbox>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-checkbox label="Editer Client"  class="privilege-checkbox" disabled></v-checkbox>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-checkbox label="Supprimer Client"  class="privilege-checkbox" disabled></v-checkbox>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-checkbox input-value="true" class="privilege-checkbox" label="Accès Base De Données" disabled></v-checkbox>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-checkbox label="Ajouter/Editer"  class="privilege-checkbox" disabled></v-checkbox>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-checkbox label="Supprimer"  class="privilege-checkbox" disabled></v-checkbox>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-checkbox input-value="true" class="privilege-checkbox" label="Accès Log" disabled></v-checkbox>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-checkbox label="Accès Statistique"  class="privilege-checkbox" disabled></v-checkbox>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-checkbox input-value="true" label="Gestion Interface Web"  class="privilege-checkbox" disabled></v-checkbox>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-checkbox input-value="true" label="Paramètres"  class="privilege-checkbox" disabled></v-checkbox>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-checkbox input-value="true" label="Gestion Utilisateurs"  class="privilege-checkbox" disabled></v-checkbox>
                                </v-col>
                            </v-row>
                            
                        </v-col>
                        <v-col cols="12" md="5" v-else>
                            <span class="logo d-block">PrimeCMS</span>
                            <p style="font-size: 16px;"><b>A propos de la plateforme</b></p>
                            <p>La plateforme de gestion des services maritime PrimeCMS est une applications Full-web personnalisées, accessibles à partir de n’importe quel terminal connecté à internet et qui vous permet de gérer vos données, documents/dossiers, avis, factures etc...</p>
                            <p>Elle vous permet aussi de créer un nombre de compte utilisateur illimité avec des permissions différentes pour mieux partager les tâches entre les employées dans l'entreprise.</p>
                            <p>De plus, vous aurez un espace attribué à vos clients accessible avec un identifiant et mot de passe, contenant toutes les informations relatives à ce client tel que les avis, les factures et tous types de documents.</p>
                            <!--<p>Pour toute réclamation ou assistance, vous pouvez nous contacter sur : <br> 25 010 794 <br> ou <br> cherni.medabderrahim@gmail.com</p>
                            <p>Tous droits réservés pour Cherni Med Abderrahim © 2020</p>-->
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            </v-col>
        </v-row>
        </v-layout>
    </v-container>
    </v-layout>
</template>

    
<script>
    import headerSidebar from '../commons/header_sidebar.component'
    import VueJwtDecode from "vue-jwt-decode"
    import profile_picture from '../../../assets/profile_picture.png'
    export default {
        name: 'my-profile',
        components: { headerSidebar },
        data: () => ({
            profile_picture_standard: profile_picture,
            snackbar: false,
            color: 'error',
            snackbarText: '',
            message: '',
            form: false,
            alert: false,
            userData: {},
            rules: {
                required: value => !!value || 'Ce champs est obligatoire.',
                username: value =>{ 
                    const pattern = /^[A-Za-z0-9]+$/
                    return value.length >= 3 && pattern.test(value) || 'Le nom d\'utilisateur doit être composé au moins de 3 caractères alpha-numériques.'
                },
                password: value => {
                    if(value){
                        return value.length >= 8 && value.length !== 0 || 'Le mot de passe doit être composé au moins de 8 caractères.'
                    }else{
                        return 'Le mot de passe doit être composé au moins de 8 caractères.'
                    }
                },
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Email invalide.'
                },
            },
            permissions: [],
            userdata: {},
            messages: {
                email: '',
                password: '',
                username: '',
                confirm_password: ''
            }
        }),
         async created(){
            this.userdata = Object.assign(VueJwtDecode.decode(this.$store.getters.getUser).userData, {agent: {}})
            if(this.userdata.agent_id > 0){
                await this.axios
                    .get('/agent/listing')
                    .then(res =>
                    {
                        let agentList = res.data
                        this.userdata.agent = agentList.filter(v => { return v.id === this.userdata.agent_id } )[0]
                    })
            }
            this.userData = Object.assign({},this.userdata)
        },
        methods: {
            update(){
                let data = Object.assign({},this.userData)
                this.messages = {
                    email: '',
                    password: '',
                    username: '',
                    confirm_password: ''
                }
                if(!this.userData.password){
                    this.messages.password = 'Vous devez entrer votre ancien mot de passe pour pouvoir effectuer des changements.'
                    this.$refs.password.focus()
                    return false
                }else if(this.userData.new_password !== this.userData.confirm_password){
                    this.messages.confirm_password = 'Ce champs devait être identique au champs du nouveau mot de passe.'
                    this.$refs.confirm_password.focus()
                    return false
                }else{
                    this.messages.password = ''
                }
                this.axios.put('/user/update', data, {}).then((res) => {
                    if(res.data.error){
                        this.messages[res.data.error] = res.data.message
                    }else{
                        this.snackbarText = 'Modification validée avec succès! La page sera refraichi dans quelques secondes pour pouvoir l\'effectuer.'
                        this.color = 'success'
                        this.snackbar = true
                        setTimeout(()=> {
                            location.reload()
                        },2000)
                    }
                })
            }
        }
    } 
</script>

<style lang="scss" scoped>
  .logo {
    font-family: 'Raleway', sans-serif;
    letter-spacing: -1px;
    font-size: 24px;
    font-weight: 700;
    margin-left: 15px;
    margin-bottom:15px;
    text-align: left;
    background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
 .privilege-checkbox >>> .v-label {
     font-size:12px;
 }
 .v-data-table >>> .text-start{
    height:85px !important
  }
  h1, h2 {
    font-weight: normal;
  }
  .no-width {
    width: 0px !important;
    min-width: 0px !important;
    padding:25px 0px !important;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .table-content {
    margin: 0 auto;
    margin-top: 25px;
    width: 96%;
    .v-input__control{
      min-width: 210px;
    }
  }
  .second-sidebar {
    box-shadow: 0 0 35px rgba(0,0,0,0.05);
    min-width:360px;
    padding:25px;
  }
  .add-btn {
    background: #207ddd;
    box-shadow: 5px 10px 20px #207ddd40;
    font-size: 12px;
  }
  .v-list--three-line .v-list-item, .v-list-item--three-line {
    min-height: 35px !important;
  }
  .v-list--rounded.v-list--three-line .v-list-item, .v-list--rounded.v-list--three-line .v-list-item:before, .v-list--rounded.v-list--three-line .v-list-item>.v-ripple__container {
      border-radius: 0px !important;
  }
  .v-list-item {
    text-align: left;
  }
  .v-list-item__title {
    font-size: 15px !important;
  }
  .v-list--nav .v-list-item:not(:last-child):not(:only-child), .v-list--rounded .v-list-item:not(:last-child):not(:only-child){
    margin-bottom: 0px !important;
  }
  .v-list-item__content{
    text-align: left !important;
  }
  .v-data-table th{
    min-height: 325px !important;
  }
</style>


// WEBPACK FOOTER //
// src/views/dashboard/users/profile.vue